import { LandscapeDisplay, SafeAreaProvider } from "@hg/layouts"
import React, { useEffect } from "react"
import Resize from "@/components/Resize"
import Toast from "@/components/Toast"
import { i18n, RecallTextPath } from "@/i18n"
import { requestGetUserStatus } from "@/services/core"
import { requestGetCurrentUser } from "@/services/user"
import { requestGetDraw } from "@/services/activity"
import { useGlobalStore } from "@/store/global"
import { GlobalView, useGlobalViewStore } from "@/store/view"
import { isDesktop } from "@/utils/ua"
import { setUser, useRoleInfo } from "@/user/session"
import { Header } from "./Header"

const Layout: React.FC<React.PropsWithChildren> = ({ children }) => {
    const globalStore = useGlobalStore()
    const user = useRoleInfo()

    // On mount: check Cookie for auto re-auth (page refresh)
    useEffect(() => {
        requestGetCurrentUser().then((res) => {
            if (res.code === 0) {
                setUser(res.data.results)
            } else {
                // Not logged in — if URL brought us to Recall, kick back to Main
                const store = useGlobalViewStore.getState()
                if (store.globalView === GlobalView.RECALL) {
                    store.setGlobalView(GlobalView.MAIN)
                    const url = new URL(window.location.href)
                    url.searchParams.delete("page")
                    window.history.replaceState({}, document.title, url.toString())
                }
            }
        })
    }, [])

    // Whenever user is set (auto re-auth or manual login), fetch activity status
    useEffect(() => {
        if (!user) return
        const fetchStatus = async () => {
            globalStore.setPlayer(null)
            const statusRes = await requestGetUserStatus()
            if (statusRes.code === 0) {
                globalStore.setPlayer({ state: statusRes.data, collection: null })
            } else {
                Toast.message(statusRes.message ?? "")
            }
        }
        fetchStatus()
    }, [user?.userId])

    // 奖品被重置提示（24 時間以内に住所を未記入）
    useEffect(() => {
        if (!user) return
        requestGetDraw().then((res) => {
            if (res.code !== 0) return
            ;(res.data.coupons as Array<{ cid: string; reset?: boolean }>)
                .filter((c) => c.reset)
                .forEach((c) => {
                    const key = `reset-alert-shown-${c.cid}`
                    if (!localStorage.getItem(key)) {
                        localStorage.setItem(key, "1")
                        alert(i18n.getRecall("message.reset_prize" as RecallTextPath))
                    }
                })
        })
    }, [user?.userId])

    return (
        <LandscapeDisplay inRotate={isDesktop() ? false : undefined}>
            <SafeAreaProvider>
                <Resize>
                    {children}
                    <Header />
                </Resize>
            </SafeAreaProvider>
        </LandscapeDisplay>
    )
}

export default Layout
